/*
  Mega menu behaviour in the header "Text labels" style.
  - Feature 006 (research R12): hover intent for mouse and trackpad. Panels open after a short delay, so passing the
    pointer over the row does not open them.
  - Feature 036 (specs/036-mega-menu-panel, research R3):
    - a close delay, so a diagonal move into the panel does not close it;
    - the top item stays a link: a mouse click goes to its page, and on touch a tap on an already open item does;
    - Down arrow on a top item opens its panel and focuses the first link.
  Keyboard Enter/Space, Escape and focus-out stay Dawn's native <details> behaviour (global.js).
*/
(() => {
  const INTENT_MS = 120; // open delay for the pointer
  const CLOSE_MS = 200; // close delay after the pointer leaves the header and panel
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  const init = () => {
    const header = document.querySelector('.header--style-labels');
    if (!header || header.dataset.hoverIntent === 'true') return;
    header.dataset.hoverIntent = 'true';
    const wrapper = header.closest('.header-wrapper') || header;
    const menus = Array.from(header.querySelectorAll('.header__inline-menu details.mega-menu'));
    let openTimer;
    let closeTimer;
    let lastPointer = 'mouse';

    const setOpen = (menu, open) => {
      if (open) menu.setAttribute('open', '');
      else menu.removeAttribute('open');
      const summary = menu.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    const closeAll = (except) => {
      menus.forEach((menu) => {
        if (menu !== except && menu.hasAttribute('open')) setOpen(menu, false);
      });
    };

    menus.forEach((menu) => {
      const summary = menu.querySelector('summary');
      if (!summary) return;

      if (canHover) {
        menu.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse') return;
          clearTimeout(closeTimer);
          clearTimeout(openTimer);
          openTimer = setTimeout(() => {
            closeAll(menu);
            setOpen(menu, true);
          }, INTENT_MS);
        });
        menu.addEventListener('pointerleave', () => clearTimeout(openTimer));
      }

      summary.addEventListener('pointerdown', (event) => {
        lastPointer = event.pointerType || 'mouse';
      });

      // The top item stays a link (Q1 → A). Keyboard clicks (detail 0) keep the native toggle.
      summary.addEventListener('click', (event) => {
        const url = summary.dataset.url;
        if (!url || event.detail === 0) return;
        if (lastPointer === 'mouse' || menu.hasAttribute('open')) {
          event.preventDefault();
          window.location.assign(url);
        }
      });

      summary.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowDown') return;
        event.preventDefault();
        closeAll(menu);
        setOpen(menu, true);
        const first = menu.querySelector('.mega-menu__content a[href]');
        if (first) first.focus();
      });
    });

    if (canHover) {
      wrapper.addEventListener('pointerenter', () => clearTimeout(closeTimer));
      wrapper.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse') return;
        clearTimeout(openTimer);
        const active = document.activeElement;
        if (active && wrapper.contains(active) && active.matches(':focus-visible')) return; // keyboard users close with Escape or focus-out
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => closeAll(null), CLOSE_MS);
      });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
